import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2053932"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "single-col" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "1-Day Admission to MoMA"),
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createElementVNode("p", { class: "des" }, "Congratulations! As one of the original purchasers in Refik Anadol's Data Universe, you are eligible to redeem a complimentary one day ticket to the Museum of Modern Art in New York City."),
  /*#__PURE__*/_createElementVNode("p", { class: "des" }, "You can present this QR code for entry:")
], -1))
const _hoisted_3 = { class: "single-col qrcode" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "single-col" }, [
  /*#__PURE__*/_createElementVNode("ol", null, [
    /*#__PURE__*/_createElementVNode("li", null, "This ticket is for one-time use only."),
    /*#__PURE__*/_createElementVNode("li", null, "The expiration date is on June 30, 2022.")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/au.svg",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("h2", null, "Autonomy")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_ctx.qrcodeImgSrc)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.qrcodeImgSrc,
              alt: ""
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _hoisted_5
    ]),
    _hoisted_6
  ]))
}